import React, { FC } from 'react';

import { useSelector } from 'react-redux';

import { VulnerabilityFiltersMenu } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/VirtualMachine/Vulnerability/VulnerabilityFiltersMenu';
import { useVulnerabilityContext } from 'containers/Visibility/Vulnerabilities/Components/hooks/context';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';
import { useSearchParams } from 'hooks/useSearchParams';

export const VulnerabilityHeaderFilters: FC = () => {
  const {
    cves,
    vulnerabilities,
    resourceType,
    useVulnerabilityV3,
  } = useSelector(selectVulnerabilities);
  const params = useSearchParams<{ tab: string }>();
  const {
    isPatchable,
    packageType,
    packageName,
    severity,
    isExploitable,
    isInternetExposed,
    updateValue,
    severities,
  } = useVulnerabilityContext();

  return (
    <VulnerabilityFiltersMenu
      updateValue={updateValue}
      isPatchable={isPatchable}
      packageType={packageType}
      packageName={packageName}
      severity={severity}
      severities={severities}
      isLoading={cves.isLoading || vulnerabilities.isLoading}
      isExploitable={isExploitable}
      isInternetExposed={isInternetExposed}
      showInternetExposure={!useVulnerabilityV3}
      selectedTab={params.tab}
      resourceType={resourceType}
    />
  );
};
